<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import LocationsList from "@/view/components/locations/LocationsList.vue";
import AddLocationsModal from "@/view/components/locations/AddLocationsModal.vue";

export default {
  name: "locations-setup",
  components: {
    LocationsList,
    AddLocationsModal
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    config() {
      return this.layoutConfig();
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Locations Setup" }]);
    this.$store.commit("setLocationVisibile", true);
  }
};
</script>

<template>
  <div>
    <v-app>
      <v-main>
        <v-card>
          <v-container fluid>
            <locations-list></locations-list>
          </v-container>
        </v-card>
      </v-main>
    </v-app>
    <add-locations-modal></add-locations-modal>
  </div>
</template>

<style scoped>
button {
  position: absolute;
  right: 10px;
}
</style>
